import { InworldConfigType } from './types';

export const Config: InworldConfigType = {
  GENERATE_TOKEN_URL: process.env.REACT_APP_INW_GENERATE_TOKEN_URL || 'http://localhost:4000',
};
